import { render, staticRenderFns } from "./TaxiCarPage.vue?vue&type=template&id=5a090cd2"
import script from "./TaxiCarPage.vue?vue&type=script&lang=js"
export * from "./TaxiCarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports